export default __webpack_public_path__ + "static/media/favicon.1e08d51d.svg";